// REQ-AUTH-ML-006 — Grace-window thin redirect.
// Forwards /signup?invite=TOKEN → /login?invite=TOKEN (and all other params).
// Full deletion is tracked as F-MIG-4 once the grace window closes.
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function SignupRedirect() {
  const params = useLocalSearchParams<Record<string, string>>();

  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v as string)}`)
    .join('&');

  const href = query ? `/login?${query}` : '/login';

  return <Redirect href={href} />;
}
